/* Rose & Born – product page additions (snippets/rb-pdp.liquid). Works on the theme's own variant flow:
   - no pre-selected size: until a size is chosen, Add to bag / Buy it now ask for a size instead of adding
   - "Only 1 left" for the chosen size
   - option A size picker: "Select size ········ Size guide" header over boxed sizes; header shows
     "Size 48 · Only 1 left" / "Please select a size"; one fit line under the sizes (fit + model, from the description)
   - Size & fit as a closed accordion (first in the theme's accordion list): fit, model, garment measurements, cm / in
   - mobile: back link on the image, slim sticky bar while the main button is off screen
   - trouser length row (hemming) and back in stock via Klaviyo (see the sections below) */
(function () {
  if (window.__rbPdp) return;
  window.__rbPdp = true;

  var UNIT_KEY = 'rb_fit_unit';

  function readJSON(el) {
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function store(key, val) {
    try { if (val === undefined) return localStorage.getItem(key); localStorage.setItem(key, val); } catch (e) { return null; }
  }
  function esc(t) {
    return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }
  function fmt(mm, unit) {
    if (unit === 'in') {
      var inch = Math.round((mm / 25.4) * 10) / 10;
      return String(inch).replace(/\.0$/, '') + ' in';
    }
    var cm = Math.round(mm) / 10;
    return String(cm).replace(/\.0$/, '') + ' cm';
  }

  function init(data) {
    var sid = data.section;
    var sv = (document.documentElement.lang || '').indexOf('sv') === 0;
    var de = (document.documentElement.lang || '').indexOf('de') === 0;
    data.strings = data.strings || {};
    data.strings.fit = data.strings.fit || (sv ? 'Passform' : de ? 'Passform' : 'Fit');
    data.strings.model = data.strings.model || (sv ? 'Modell' : de ? 'Modell' : 'Model');
    data.strings.wears = data.strings.wears || (sv ? 'bär storlek' : de ? 'trägt Größe' : 'wears size');
    data.strings.pleaseSelect = data.strings.pleaseSelect || (sv ? 'Välj en storlek' : de ? 'Bitte wählen Sie eine Größe' : 'Please select a size');
    data.strings.onlyOne = data.strings.onlyOne || (sv ? 'Endast 1 kvar' : de ? 'Nur noch 1 verfügbar' : 'Only 1 left');
    data.strings.sizeFit = data.strings.sizeFit || (sv ? 'Storlek & passform' : de ? 'Größe & Passform' : 'Size & fit');
    data.strings.measurements = data.strings.measurements || (sv ? 'Plaggets mått' : de ? 'Maße des Kleidungsstücks' : 'Garment measurements');
    var info = document.getElementById('MainProduct-' + sid);
    if (!info) return;
    var form = document.getElementById('product-form-' + sid);
    var button = document.getElementById('ProductSubmitButton-' + sid);
    var stock = document.getElementById('RbStock-' + sid);
    var hint = document.getElementById('RbHint-' + sid);
    var fit = document.getElementById('RbFit-' + sid);
    var bar = document.getElementById('RbBar-' + sid);
    var byId = {};
    (data.variants || []).forEach(function (v) { byId[v.id] = v; });

    var needsSize = function () { return info.hasAttribute('data-rb-needs-size'); };
    var current = null; // chosen variant (from our data)

    /* ---------- Size & fit ---------- */
    // cm / in (Carl 1 Oct): the market decides the default (inches for the US and UK, cm everywhere else). A visitor's own
    // switch is remembered per default, so a choice made while browsing the US store never carries over to Sweden.
    var UNIT_PREF = UNIT_KEY + '_' + (data.unit === 'in' ? 'in' : 'cm');
    var unit = store(UNIT_PREF) || data.unit || 'cm';
    if (unit !== 'cm' && unit !== 'in') unit = 'cm';

    function rowFor(size) {
      var g = data.guide;
      if (!g || size == null) return -1;
      var s = String(size).trim();
      var i = g.eu.indexOf(s);
      if (i > -1) return i;
      var conv = g.conv || {};
      var eu = conv.eu_;
      if (!eu) return -1;
      var keys = ['us_uk_waist', 'international', 'us_', 'uk_', 'us_uk_collar', 'eu_collar'];
      for (var k = 0; k < keys.length; k++) {
        var list = conv[keys[k]];
        if (!list) continue;
        var j = list.indexOf(s);
        if (j > -1 && eu[j] != null) {
          var r = g.eu.indexOf(String(eu[j]));
          if (r > -1) return r;
        }
      }
      return -1;
    }

    function paintFit() {
      if (!fit || !data.guide) return;
      paintFacts();
      fit.setAttribute('data-unit', unit);
      [].forEach.call(fit.querySelectorAll('.rb-fit__unit'), function (b) {
        b.setAttribute('aria-checked', b.getAttribute('data-unit') === unit ? 'true' : 'false');
      });
      var list = fit.querySelector('[data-rb-fit-list]');
      var lead = fit.querySelector('[data-rb-fit-lead]');
      if (!current || needsSize()) {
        list.hidden = true;
        lead.hidden = false;
        syncAccordion();
        return;
      }
      var r = rowFor(current.size);
      var html = '';
      if (r > -1) {
        data.guide.rows.forEach(function (row) {
          var mm = row.mm[r];
          if (mm == null || isNaN(mm) || mm <= 0) return;
          html += '<div class="rb-fit__row"><dt>' + esc(row.label) + '</dt><dd>' + fmt(mm, unit) + '</dd></div>';
        });
      }
      lead.hidden = false;
      if (html) {
        lead.textContent = data.strings.sizeLabel + ' ' + current.size;
      } else {
        // No measured values for this size: say so and offer Client Care (same chat as the care line, see rb-cart-drawer.js)
        lead.innerHTML = esc(data.strings.sizeLabel + ' ' + current.size + ': ' + data.strings.noMeasure) + ' ' +
          '<a href="/pages/contact" data-rb-care>' + esc(data.strings.contact || 'Please contact us for more information.') + '</a>';
      }
      list.innerHTML = html;
      list.hidden = !html;
      syncAccordion();
    }

    /* Fit + model facts, read from the product description the team already writes
       ("Normal fit, choose your regular size" bullet, "The model is 189cm tall and wears size 50.") */
    var facts = { fit: null, modelCm: null, modelSize: null };
    (function () {
      var desc = info.querySelector('.product__description');
      if (!desc) return;
      [].some.call(desc.querySelectorAll('li'), function (li) {
        var t = li.textContent.replace(/\s+/g, ' ').trim();
        if (t.length < 70 && /\b(fit|passform)\b/i.test(t)) { facts.fit = t; return true; }
        return false;
      });
      var txt = desc.textContent.replace(/\s+/g, ' ');
      var m = txt.match(/model(?:len)?\b[^.]*?(\d{3})\s?cm[^.]*?(?:wears|wearing|bär|har)\s+(?:a\s+)?(?:size|storlek)\s+([A-Za-z0-9\/]+)/i);
      if (m) { facts.modelCm = parseInt(m[1], 10); facts.modelSize = m[2]; }
    })();
    function height(cm) {
      if (unit !== 'in') return cm + ' cm';
      var inches = Math.round(cm / 2.54);
      return Math.floor(inches / 12) + '\u2032' + (inches % 12) + '\u2033';
    }
    function paintFacts() {
      if (!fit || (!facts.fit && !facts.modelCm)) return;
      var box = fit.querySelector('[data-rb-fit-facts]');
      if (!box) {
        box = document.createElement('dl');
        box.className = 'rb-fit__facts';
        box.setAttribute('data-rb-fit-facts', '');
        fit.querySelector('.rb-fit__head').insertAdjacentElement('beforebegin', box);
      }
      var html = '';
      if (facts.fit) html += '<div class="rb-fit__row"><dt>' + data.strings.fit + '</dt><dd>' + esc(facts.fit) + '</dd></div>';
      if (facts.modelCm) html += '<div class="rb-fit__row"><dt>' + data.strings.model + '</dt><dd>' + height(facts.modelCm) + ' \u00b7 ' + data.strings.wears + ' ' + esc(facts.modelSize) + '</dd></div>';
      box.innerHTML = html;
    }

    if (fit) {
      fit.addEventListener('click', function (e) {
        var b = e.target.closest('.rb-fit__unit');
        if (!b) return;
        unit = b.getAttribute('data-unit');
        store(UNIT_PREF, unit);
        paintFit();
        paintFitLine();
        if (hem) hem.onSize();
      });
    }

    /* ---------- Complete the look (rb-cart-upsell, mode "pdp"): below the info accordions ---------- */
    var ctl = info.querySelector('rb-cart-upsell.rb-upsell--pdp');
    var accList = info.querySelector('.product-info-accordion-container');
    if (ctl && accList && accList.parentNode && accList.nextSibling !== ctl) accList.parentNode.insertBefore(ctl, accList.nextSibling);

    /* ---------- Size & fit as a closed accordion, styled like the theme's ("Deliveries", "Garment Care") ---------- */
    var acc = null, accButton = null, accBody = null;
    if (fit) {
      var title = fit.querySelector('.rb-fit__title');
      if (title) title.textContent = data.strings.measurements;
      acc = document.createElement('div');
      acc.className = 'product-info-accordion rb-fit-acc';
      acc.innerHTML = '<button type="button" class="product-info-accordion__button rb-fit-acc__button" aria-expanded="false" aria-controls="RbFitBody-' + sid + '">' +
        '<span>' + esc(data.strings.sizeFit) + '</span><span class="accordion-icon">+</span></button>' +
        '<div id="RbFitBody-' + sid + '" class="product-info-accordion__content rb-fit-acc__content" aria-hidden="true" style="max-height:0;overflow:hidden"></div>';
      accButton = acc.firstChild;
      accBody = acc.lastChild;
      var list0 = info.querySelector('.product-info-accordion-container');
      if (list0) list0.insertBefore(acc, list0.firstChild);
      else fit.parentNode.insertBefore(acc, fit);
      accBody.appendChild(fit);
      /* No data-accordion attribute, so the theme's own accordion script ignores this button; we toggle it here
         and close the theme's open accordions the same way the theme does (one open at a time). */
      accButton.addEventListener('click', function () {
        var open = accButton.getAttribute('aria-expanded') !== 'true';
        if (open) {
          [].forEach.call(document.querySelectorAll('.product-info-accordion__button[aria-expanded="true"]'), function (b) {
            if (b === accButton) return;
            b.setAttribute('aria-expanded', 'false');
            var c = b.nextElementSibling;
            if (c) { c.setAttribute('aria-hidden', 'true'); c.style.maxHeight = '0'; c.style.overflow = 'hidden'; }
            var ic = b.querySelector('.accordion-icon');
            if (ic) ic.textContent = '+';
          });
        }
        accButton.setAttribute('aria-expanded', open ? 'true' : 'false');
        accBody.setAttribute('aria-hidden', open ? 'false' : 'true');
        accBody.style.maxHeight = open ? accBody.scrollHeight + 'px' : '0';
        accButton.querySelector('.accordion-icon').textContent = open ? '\u2212' : '+';
      });
    }
    function syncAccordion() {
      if (accBody && accButton && accButton.getAttribute('aria-expanded') === 'true') accBody.style.maxHeight = accBody.scrollHeight + 'px';
    }

    /* ---------- option A colour row: "Colour Beige" over smaller thumbnails ---------- */
    info.classList.add('rb-pdp-on');
    (function () {
      var listEl = info.querySelector('.model-picker__list');
      if (!listEl || listEl.previousElementSibling && listEl.previousElementSibling.classList.contains('rb-colour-head')) return;
      var selected = listEl.querySelector('.model-picker__link[aria-current="page"] .model-picker__name');
      var head = document.createElement('p');
      head.className = 'rb-colour-head';
      head.innerHTML = esc(sv ? 'Färg' : de ? 'Farbe' : 'Colour') + (selected ? ' <span>' + esc(selected.textContent.trim()) + '</span>' : '');
      listEl.parentNode.insertBefore(head, listEl);
    })();

    /* ---------- option A size header + fit line ---------- */
    var sizeHead = null, sizeLabel = null, fitLine = null, hinted = false;
    (function () {
      var cont = info.querySelector('.variant-selection-container');
      var pill = cont && cont.querySelector('.product-form__input--pill:not(.hidden)');
      if (!cont) return;
      if (pill) {
        sizeHead = document.createElement('div');
        sizeHead.className = 'rb-size-head';
        sizeLabel = document.createElement('span');
        sizeLabel.className = 'rb-size-head__label';
        sizeLabel.setAttribute('aria-live', 'polite');
        sizeHead.appendChild(sizeLabel);
        var guide = cont.querySelector('.size-guide-button-wrapper');
        if (guide) sizeHead.appendChild(guide);
        cont.insertBefore(sizeHead, cont.firstChild);
        info.classList.add('rb-pdp-sizes');
      }
      if (facts.fit || facts.modelCm) {
        fitLine = document.createElement('p');
        fitLine.className = 'rb-fit-line';
        cont.insertAdjacentElement('afterend', fitLine);
      }
    })();
    function paintHead() {
      if (!sizeLabel) return;
      sizeLabel.classList.remove('rb-size-head__label--warn');
      if (needsSize()) {
        sizeLabel.textContent = hinted ? data.strings.pleaseSelect : data.strings.select;
        if (hinted) sizeLabel.classList.add('rb-size-head__label--warn');
      } else if (current) {
        sizeLabel.innerHTML = esc(data.strings.sizeLabel) + // Carl 1 Oct: the black size box already shows the size
          
          (current.available && current.last ? ' <span class="rb-size-head__stock">\u00b7 ' + esc(data.strings.onlyOne) + '</span>' : '') +
          (!current.available ? ' <span class="rb-size-head__soldout">\u00b7 ' + esc(sv ? 'Slutsåld' : de ? 'Ausverkauft' : 'Sold out') + '</span>' : '');
      } else {
        sizeLabel.textContent = data.strings.select;
      }
    }
    function paintFitLine() {
      if (!fitLine) return;
      // Carl 1 Oct: two aligned rows (Fit / Model) instead of one line that wraps on mobile
      var rows = [];
      if (facts.fit) rows.push('<span class="rb-fit-line__row"><span class="rb-fit-line__k">' + esc(data.strings.fit) + '</span><span>' + esc(facts.fit) + '</span></span>');
      if (facts.modelCm) rows.push('<span class="rb-fit-line__row"><span class="rb-fit-line__k">' + esc(data.strings.model) + '</span><span>' + esc(height(facts.modelCm) + ', ' + data.strings.wears + ' ' + facts.modelSize) + '</span></span>');
      fitLine.innerHTML = rows.join('');
    }

    /* ---------- Trouser length (Carl 30 Sep, canvas "Trouser length" v2) ----------
       Products tagged "Hemming: tailored" (length + turn-ups) or "Hemming: 5-pocket" (length only).
       One compact "Length" row between the fit line and Add to bag; "Change" opens a bottom sheet (mobile) or a side
       panel (desktop). Saved choices become line item properties on the order: Inseam, Turn-ups, Alteration, _hemming.
       Unhemmed = no properties. Max length = the unhemmed inseam for the chosen size (size guide). */
    var hem = null;
    if (data.hem && data.hem.mode && form) hem = (function () {
      var tailored = data.hem.mode === 'tailored';
      // Carl 30 Sep: tailored + tuxedo trousers come unfinished (always need a tailor) – don't quote a length;
      // jeans / 5-pocket come in a standard 34" length (= the max for "hemmed to my length").
      var unfinished = !!data.hem.unfinished;
      var STD_MM = 860;
      var T = sv ? {
        length: 'Längd', change: 'Ändra', unhemmed: 'Ofållad', needsTailor: 'Levereras ofållad och behöver fållas av en skräddare',
        standard: 'Standardlängd', standardSub: '34\u2033 innerben ({len})',
        hemmed: 'Fållad till min längd', hemmedSub: 'Av vår skräddare · ingen extra kostnad · +3–5 arbetsdagar',
        inseam: 'Innerbenslängd', max: 'max {len}', turnups: 'Uppslag', none: 'Inget', unitLabel: 'Måttenhet',
        tick: 'Jag förstår att fållade plagg inte kan returneras.', save: 'Spara längd', close: 'Stäng',
        howto: 'Mät innerbenet på ett par byxor som passar dig, från grensömmen till fållen.',
        summary: 'Fållad · {len}', summaryTurn: ' · {t} uppslag', summarySub: 'Kan ej returneras · +3–5 arbetsdagar',
        errLen: 'Ange din innerbenslängd.', errMax: 'Max {len} i storlek {size}.', errMin: 'Minst {len}.', errTick: 'Bekräfta rutan för att fortsätta.',
        errSize: 'För lång för storlek {size}. Ändra längden.'
      } : de ? {
        length: 'Länge', change: 'Ändern', unhemmed: 'Ungesäumt', needsTailor: 'Wird ungesäumt geliefert und muss von einem Schneider gekürzt werden',
        standard: 'Standardlänge', standardSub: '34\u2033 Innenbeinlänge ({len})',
        hemmed: 'Auf meine Länge gekürzt', hemmedSub: 'Durch unseren Schneider · ohne Aufpreis · +3–5 Werktage',
        inseam: 'Innenbeinlänge', max: 'max. {len}', turnups: 'Umschlag', none: 'Ohne', unitLabel: 'Maßeinheit',
        tick: 'Mir ist bewusst, dass gekürzte Artikel nicht zurückgegeben werden können.', save: 'Länge speichern', close: 'Schließen',
        howto: 'Messen Sie die Innenbeinlänge einer gut sitzenden Hose, vom Schritt bis zum Saum.',
        summary: 'Gekürzt · {len}', summaryTurn: ' · {t} Umschlag', summarySub: 'Vom Umtausch ausgeschlossen · +3–5 Werktage',
        errLen: 'Bitte geben Sie Ihre Innenbeinlänge ein.', errMax: 'Max. {len} in Größe {size}.', errMin: 'Mindestens {len}.', errTick: 'Bitte bestätigen Sie das Kästchen, um fortzufahren.',
        errSize: 'Zu lang für Größe {size}. Bitte ändern Sie die Länge.'
      } : {
        length: 'Length', change: 'Change', unhemmed: 'Unhemmed', needsTailor: 'Comes unhemmed – needs hemming by a tailor',
        standard: 'Standard length', standardSub: '34\u2033 inseam ({len})',
        hemmed: 'Hemmed to my length', hemmedSub: 'By our tailor · no extra cost · adds 3–5 business days',
        inseam: 'Inseam', max: 'max {len}', turnups: 'Turn-ups', none: 'None', unitLabel: 'Unit',
        tick: 'I understand that hemmed items can’t be returned.', save: 'Save length', close: 'Close',
        howto: 'Measure the inside leg of a pair that fits you, from the crotch seam to the hem.',
        summary: 'Hemmed · {len}', summaryTurn: ' · {t} turn-ups', summarySub: 'Final sale · adds 3–5 business days',
        errLen: 'Enter your inseam.', errMax: 'Max {len} in size {size}.', errMin: 'At least {len}.', errTick: 'Please tick the box to continue.',
        errSize: 'Too long for size {size} – change the length.'
      };
      // suits and tuxedos (Carl 1 Oct): the row is about the trousers
      // The row label is short so it fits the label column next to Fit / Model / In store; the panel title says it in full.
      T.title = T.length;
      if (data.hem.suit) {
        T.title = sv ? 'Byxlängd' : (typeof de !== 'undefined' && de) ? 'Hosenlänge' : 'Trouser length';
        T.length = sv ? 'Byxor' : (typeof de !== 'undefined' && de) ? 'Hose' : 'Trousers';
      }
      function t(str, o) { return str.replace(/\{(\w+)\}/g, function (m, k) { return o && o[k] != null ? o[k] : m; }); }
      /* cm or inches (Carl 1 Oct): same unit as the Size & fit toggle (US visitors start in inches). Values are kept in mm;
         turn-ups: None or 5 cm only (Carl 1 Oct) – shown as 2 in for inches, stored as 50 mm either way.
         Order properties show the chosen unit first, the other in brackets. */
      var TURNS = { cm: [50], in: [50 / 25.4] };
      var FRAC = { '1.25': '1\u00bc', '1.5': '1\u00bd', '1.75': '1\u00be', '2': '2', '2.25': '2\u00bc' };
      var MIN_MM = 600;
      var state = { hemmed: false, mm: null, turn: 'none', unit: 'cm' }; // saved; turn = 'none' or mm
      function hemUnit() { return unit === 'in' ? 'in' : 'cm'; }
      function toMm(v) { v = parseFloat(String(v).replace(',', '.')); if (isNaN(v)) return null; return Math.round(hemUnit() === 'in' ? v * 25.4 : v * 10); }
      function show(mm, u) { return fmt(mm, u || hemUnit()); }
      function inputVal(mm) { if (mm == null) return ''; return hemUnit() === 'in' ? String(Math.round(mm / 25.4 * 10) / 10) : String(Math.round(mm) / 10); }
      function turnOptions(u) { return TURNS[u].map(function (v) { return u === 'in' ? Math.round(v * 25.4) : v; }); }
      function turnLabel(mm, u) {
        u = u || hemUnit();
        if (u === 'in') { var inch = Math.round(mm / 25.4 * 4) / 4; return (FRAC[String(inch)] || String(Math.round(mm / 25.4 * 10) / 10)) + ' in'; }
        return String(Math.round(mm) / 10).replace(/\.0$/, '') + ' cm';
      }
      function snapTurn(mm, u) {
        if (mm === 'none') return 'none';
        return turnOptions(u).reduce(function (a, b) { return Math.abs(b - mm) < Math.abs(a - mm) ? b : a; });
      }
      function maxMm() {
        if (!unfinished) return hemUnit() === 'in' ? 864 : STD_MM; // 34 in = 86.4 cm: max 34 in or 86 cm
        if (!current || !data.guide) return null;
        var r = rowFor(current.size);
        if (r < 0) return null;
        var row = (data.guide.rows || []).filter(function (x) { return x.key === 'inseam'; })[0];
        var mm = row && row.mm[r];
        return mm > 0 ? mm : null;
      }

      /* the row */
      var wrap = document.createElement('div');
      wrap.className = 'rb-hem';
      wrap.innerHTML =
        '<button type="button" class="rb-hem__row" aria-haspopup="dialog" aria-controls="RbHemPanel-' + sid + '">' +
          '<span class="rb-hem__label">' + esc(T.length) + '</span>' +
          '<span class="rb-hem__value"><span class="rb-hem__main" data-rb-hem-main></span><span class="rb-hem__sub" data-rb-hem-sub></span></span>' +
          '<span class="rb-hem__change">' + esc(T.change) + '</span>' +
        '</button>';
      var anchor = fitLine || info.querySelector('.variant-selection-container');
      if (!anchor) return null;
      anchor.insertAdjacentElement('afterend', wrap);
      info.classList.add('rb-pdp-hem');
      var rowBtn = wrap.querySelector('.rb-hem__row');
      var mainEl = wrap.querySelector('[data-rb-hem-main]');
      var subEl = wrap.querySelector('[data-rb-hem-sub]');

      function problem() {
        if (!state.hemmed) return null;
        var mx = maxMm();
        if (mx && state.mm > mx) return t(T.errSize, { size: current.size });
        return null;
      }
      function paintRow() {
        var err = problem();
        wrap.classList.toggle('rb-hem--warn', !!err);
        if (state.hemmed) {
          mainEl.textContent = t(T.summary, { len: show(state.mm) }) + (tailored && state.turn !== 'none' ? t(T.summaryTurn, { t: turnLabel(state.turn) }) : '');
          subEl.textContent = err || T.summarySub;
          subEl.classList.toggle('rb-hem__sub--final', !err);
        } else {
          mainEl.textContent = unfinished ? T.unhemmed : T.standard;
          subEl.textContent = unfinished ? T.needsTailor : t(T.standardSub, { len: Math.round(STD_MM / 10) + ' cm' });
          subEl.classList.remove('rb-hem__sub--final');
        }
        props = {
          'Inseam': state.hemmed ? show(state.mm, state.unit) + ' (' + show(state.mm, state.unit === 'in' ? 'cm' : 'in') + ')' : '',
          'Turn-ups': state.hemmed && tailored ? (state.turn === 'none' ? 'None (plain hem)' :
            turnLabel(state.turn, state.unit) + ' (' + turnLabel(state.turn, state.unit === 'in' ? 'cm' : 'in') + ')') : '',
          'Alteration': state.hemmed ? 'Hemmed to length – final sale' : '',
          '_hemming': state.hemmed ? data.hem.mode : ''
        };
        info.classList.toggle('rb-pdp-hem-on', state.hemmed);
      }
      /* Add the length to the add-to-bag request. The theme renders the product form twice with the same id
         (main + sticky), so instead of hidden inputs we hook FormData (product-form.js uses new FormData(form)). */
      var props = {};
      // capture on document: the theme swaps the form's markup on size changes, so per-form listeners would get lost
      document.addEventListener('formdata', function (e) {
        if (!e.target || e.target.id !== form.id) return;
        Object.keys(props).forEach(function (k) { if (props[k]) e.formData.set('properties[' + k + ']', props[k]); });
      }, true);

      /* the panel (bottom sheet on mobile, side panel on desktop) */
      var panel = document.createElement('div');
      panel.className = 'rb-hem-panel';
      panel.id = 'RbHemPanel-' + sid;
      panel.hidden = true;
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      panel.setAttribute('aria-labelledby', 'RbHemTitle-' + sid);
      var turnHtml = tailored ? '<p class="rb-hem-p__label">' + esc(T.turnups) + '</p><div class="rb-hem-p__turns" role="radiogroup" aria-label="' + esc(T.turnups) + '" data-rb-hem-turns></div>' : '';
      panel.innerHTML =
        '<div class="rb-hem-p__overlay" data-rb-hem-close></div>' +
        '<div class="rb-hem-p__inner">' +
          '<div class="rb-hem-p__head"><h2 class="rb-hem-p__title" id="RbHemTitle-' + sid + '">' + esc(T.title) + '</h2>' +
          '<button type="button" class="rb-hem-p__close" data-rb-hem-close aria-label="' + esc(T.close) + '"><svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="1.2" fill="none"/></svg></button></div>' +
          '<label class="rb-hem-p__opt"><input type="radio" name="RbHemMode-' + sid + '" value="0"><span class="rb-hem-p__txt"><span class="rb-hem-p__name">' + esc(unfinished ? T.unhemmed : T.standard) + '</span><span class="rb-hem-p__desc" data-rb-hem-full></span></span></label>' +
          '<div class="rb-hem-p__opt rb-hem-p__opt--hem"><label class="rb-hem-p__optlabel"><input type="radio" name="RbHemMode-' + sid + '" value="1"><span class="rb-hem-p__txt"><span class="rb-hem-p__name">' + esc(T.hemmed) + '</span><span class="rb-hem-p__desc">' + esc(T.hemmedSub) + '</span></span></label>' +
            '<div class="rb-hem-p__fields" data-rb-hem-fields>' +
              '<div class="rb-hem-p__labelrow"><label class="rb-hem-p__label" for="RbHemLen-' + sid + '">' + esc(T.inseam) + '</label>' +
                '<div class="rb-hem-p__units" role="radiogroup" aria-label="' + esc(T.unitLabel) + '">' +
                  '<button type="button" role="radio" data-hem-unit="cm">cm</button><button type="button" role="radio" data-hem-unit="in">in</button></div></div>' +
              '<div class="rb-hem-p__len"><input id="RbHemLen-' + sid + '" type="text" inputmode="decimal" autocomplete="off" class="rb-hem-p__input"><span data-rb-hem-unit></span><span class="rb-hem-p__max" data-rb-hem-max></span></div>' +
              '<p class="rb-hem-p__help">' + esc(T.howto) + '</p>' + turnHtml +
            '</div></div>' +
          '<label class="rb-hem-p__tick" data-rb-hem-tickrow><input type="checkbox" data-rb-hem-tick><span>' + esc(T.tick) + '</span></label>' +
          '<p class="rb-hem-p__err" role="alert" data-rb-hem-err></p>' +
          '<button type="button" class="rb-hem-p__save button" data-rb-hem-save>' + esc(T.save) + '</button>' +
        '</div>';
      document.body.appendChild(panel);
      var radios = panel.querySelectorAll('input[type=radio]');
      var lenInput = panel.querySelector('.rb-hem-p__input');
      var tick = panel.querySelector('[data-rb-hem-tick]');
      var errEl = panel.querySelector('[data-rb-hem-err]');
      var draft = null, lastFocus = null;

      function paintPanel() {
        var mx = maxMm();
        panel.querySelector('[data-rb-hem-full]').textContent = unfinished ? T.needsTailor : t(T.standardSub, { len: Math.round(STD_MM / 10) + ' cm' });
        panel.querySelector('[data-rb-hem-max]').textContent = mx ? t(T.max, { len: show(mx) }) : '';
        radios[0].checked = !draft.hemmed;
        radios[1].checked = draft.hemmed;
        panel.classList.toggle('rb-hem-panel--hemmed', draft.hemmed);
        var u = hemUnit();
        panel.querySelector('[data-rb-hem-unit]').textContent = u;
        [].forEach.call(panel.querySelectorAll('[data-hem-unit]'), function (b) {
          b.setAttribute('aria-checked', b.getAttribute('data-hem-unit') === u ? 'true' : 'false');
        });
        var turns = panel.querySelector('[data-rb-hem-turns]');
        if (turns) {
          turns.innerHTML = ['none'].concat(turnOptions(u)).map(function (v) {
            var on = String(v) === String(draft.turn);
            return '<button type="button" class="rb-hem-p__turn" role="radio" aria-checked="' + on + '" data-turn="' + v + '">' +
              esc(v === 'none' ? T.none : turnLabel(v, u)) + '</button>';
          }).join('');
        }
      }
      function open() {
        if (needsSize()) { askForSize(); return; }
        draft = { hemmed: state.hemmed, mm: state.mm, turn: snapTurn(state.turn, hemUnit()) };
        lenInput.value = inputVal(draft.mm);
        tick.checked = state.hemmed;
        errEl.textContent = '';
        paintPanel();
        lastFocus = document.activeElement;
        panel.hidden = false;
        document.documentElement.classList.add('rb-hem-open');
        requestAnimationFrame(function () { panel.classList.add('is-open'); (draft.hemmed ? lenInput : radios[0]).focus({ preventScroll: true }); });
      }
      function close() {
        panel.classList.remove('is-open');
        document.documentElement.classList.remove('rb-hem-open');
        panel.hidden = true;
        if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
      }
      function save() {
        if (!draft.hemmed) { state = { hemmed: false, mm: null, turn: 'none', unit: hemUnit() }; paintRow(); close(); return; }
        var mm = toMm(lenInput.value), mx = maxMm();
        var err = null;
        if (mm == null) err = T.errLen;
        else if (mm < MIN_MM) err = t(T.errMin, { len: show(MIN_MM) });
        else if (mx && mm > mx) err = t(T.errMax, { len: show(mx), size: current.size });
        else if (!tick.checked) err = T.errTick;
        errEl.textContent = err || '';
        if (err) { (err === T.errTick ? tick : lenInput).focus(); return; }
        state = { hemmed: true, mm: mm, turn: tailored ? draft.turn : 'none', unit: hemUnit() };
        paintRow();
        close();
      }
      rowBtn.addEventListener('click', open);
      panel.addEventListener('click', function (e) {
        if (e.target === panel || e.target.closest('[data-rb-hem-close]')) { close(); return; }
        if (e.target.closest('[data-rb-hem-save]')) { save(); return; }
        var turn = e.target.closest('.rb-hem-p__turn');
        if (turn) { var tv = turn.getAttribute('data-turn'); draft.turn = tv === 'none' ? 'none' : Number(tv); paintPanel(); return; }
        var ub = e.target.closest('[data-hem-unit]');
        if (ub && ub.getAttribute('data-hem-unit') !== hemUnit()) {
          var typed = toMm(lenInput.value);
          unit = ub.getAttribute('data-hem-unit');
          store(UNIT_PREF, unit);
          lenInput.value = inputVal(typed);
          draft.turn = snapTurn(draft.turn, unit);
          paintPanel();
          paintRow();
          paintFit();
          paintFitLine();
        }
      });
      panel.addEventListener('change', function (e) {
        if (e.target.name === 'RbHemMode-' + sid) {
          draft.hemmed = e.target.value === '1';
          errEl.textContent = '';
          paintPanel();
          if (draft.hemmed) lenInput.focus();
        }
      });
      lenInput.addEventListener('focus', function () { if (!draft.hemmed) { draft.hemmed = true; paintPanel(); } });
      panel.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { e.stopPropagation(); close(); }
        if (e.key === 'Enter' && e.target === lenInput) { e.preventDefault(); save(); }
      });

      paintRow();
      return {
        onSize: paintRow,
        blocked: function () { return !!problem(); },
        open: open
      };
    })();

    /* Hemming paused in Theme settings (R&B · Personalisation): a quiet row instead of the length choice */
    if (data.hemOff && form) (function () {
      var anchor = fitLine || info.querySelector('.variant-selection-container');
      if (!anchor) return;
      var w = document.createElement('div');
      w.className = 'rb-hem rb-hem--off';
      w.innerHTML = '<div class="rb-hem__row" aria-disabled="true"><span class="rb-hem__label">' + (sv ? 'Längd' : de ? 'Länge' : 'Length') + '</span>' +
        '<span class="rb-hem__value"><span class="rb-hem__main">' + (sv ? 'Inte tillgängligt just nu' : de ? 'Derzeit nicht verfügbar' : 'Not available right now') + '</span></span></div>';
      anchor.insertAdjacentElement('afterend', w);
    })();

    /* ---------- Back in stock (Klaviyo, Carl 30 Sep): one button, no strike-through ----------
       A sold-out size stays clickable. When one is chosen, the main button is replaced by "Notify me when back" →
       inline email field → confirmation, in the same spot. Sign-ups go straight to Klaviyo's back-in-stock
       (client API, public key only) and are handled by the "Back in Stock" flow. The optional tick box also
       subscribes the email to the newsletter list. The old app's button is hidden with CSS. */
    var bis = null;
    if (data.bis && data.bis.key) bis = (function () {
      var T = sv ? {
        notify: 'Meddela mig när den är tillbaka', soldOut: 'Slutsåld', others: 'Andra storlekar i lager: {list}',
        title: 'Få ett mejl när storlek {size} är tillbaka', email: 'E-postadress', submit: 'Meddela mig',
        news: 'Skicka mig också nyheter från Rose & Born (valfritt)', done: 'Vi mejlar dig när storlek {size} är tillbaka.',
        sentTo: 'Skickas till {email}', change: 'Ändra', errEmail: 'Ange en giltig e-postadress.', errSend: 'Något gick fel. Försök igen.'
      } : de ? {
        notify: 'Benachrichtigen, wenn wieder verfügbar', soldOut: 'Ausverkauft', others: 'Andere Größen auf Lager: {list}',
        title: 'E-Mail erhalten, wenn Größe {size} wieder verfügbar ist', email: 'E-Mail-Adresse', submit: 'Benachrichtigen',
        news: 'Senden Sie mir auch Neuigkeiten von Rose & Born (optional)', done: 'Wir benachrichtigen Sie per E-Mail, sobald Größe {size} wieder verfügbar ist.',
        sentTo: 'Wird gesendet an {email}', change: 'Ändern', errEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.', errSend: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.'
      } : {
        notify: 'Notify me when back', soldOut: 'Sold out', others: 'Other sizes in stock: {list}',
        title: 'Get an email when size {size} is back', email: 'Email address', submit: 'Notify me',
        news: 'Also send me news from Rose & Born (optional)', done: 'We’ll email you when size {size} is back.',
        sentTo: 'Sent to {email}', change: 'Change', errEmail: 'Enter a valid email address.', errSend: 'Something went wrong – please try again.'
      };
      function t(str, o) { return str.replace(/\{(\w+)\}/g, function (m, k) { return o && o[k] != null ? o[k] : m; }); }
      var EMAIL_KEY = 'rb_bis_email';
      var pf = info.querySelector('product-form') || (form && form.parentNode);
      if (!pf) return null;
      var box = document.createElement('div');
      box.className = 'rb-bis';
      box.hidden = true;
      box.setAttribute('aria-live', 'polite');
      pf.parentNode.insertBefore(box, pf);
      var state = 'button', shownFor = null;
      var inStock = (data.variants || []).filter(function (v) { return v.available; }).map(function (v) { return v.size; });
      // listed in size order (was variant order: "50, 48, 46, 154")
      if (inStock.every(function (x) { return !isNaN(parseFloat(x)); })) inStock.sort(function (a, b) { return parseFloat(a) - parseFloat(b); });
      if (inStock.length) info.classList.add('rb-pdp-some-left');

      function mask(email) {
        var parts = String(email).split('@');
        return parts[0].charAt(0) + '••••@' + (parts[1] || '');
      }
      function done(id) { try { return sessionStorage.getItem('rb_bis_' + id); } catch (e) { return null; } }
      function paint() {
        var size = current ? current.size : '';
        if (state === 'button') {
          // Carl 6 Oct: no "Other sizes in stock" line under the button (the size buttons already show it).
          box.innerHTML = '<button type="button" class="rb-bis__open product-form__submit button button--full-width button--primary" data-rb-bis-open>' + esc(T.notify) + '</button>';
        } else if (state === 'form') {
          var saved = store(EMAIL_KEY) || '';
          box.innerHTML = '<form class="rb-bis__box" novalidate data-rb-bis-form>' +
            '<p class="rb-bis__title" id="RbBisTitle-' + sid + '">' + esc(t(T.title, { size: size })) + '</p>' +
            '<div class="rb-bis__row"><input type="email" class="rb-bis__email" name="email" autocomplete="email" placeholder="' + esc(T.email) + '" aria-labelledby="RbBisTitle-' + sid + '" value="' + esc(saved) + '">' +
            '<button type="submit" class="rb-bis__submit">' + esc(T.submit) + '</button></div>' +
            (data.bis.list ? '<label class="rb-bis__news"><input type="checkbox" name="news"><span>' + esc(T.news) + '</span></label>' : '') +
            '<p class="rb-bis__err" role="alert"></p></form>';
          var input = box.querySelector('.rb-bis__email');
          setTimeout(function () { input.focus(); }, 30);
        } else {
          var email = done(current.id) || store(EMAIL_KEY) || '';
          // Carl 1 Oct (evening): one calm Oyster panel in the button's place: confirmation, the address, Change.
          // "Other sizes in stock" is left out here (the size buttons already show it).
          box.innerHTML = '<div class="rb-bis__done" role="status">' +
            '<p class="rb-bis__done-title"><svg viewBox="0 0 14 14" aria-hidden="true" focusable="false"><path d="M2.5 7.4l2.9 2.9 6.1-6.3" stroke="currentColor" stroke-width="1.2" fill="none"/></svg>' +
            '<span>' + esc(t(T.done, { size: size }).replace(/\.$/, '')) + '</span></p>' +
            '<p class="rb-bis__done-meta">' + esc(mask(email)) + '</p>' +
            '<button type="button" class="rb-bis__done-change" data-rb-bis-change>' + esc(T.change) + '</button></div>';
        }
      }
      function update() {
        var show = !!(current && !current.available && !needsSize());
        info.classList.toggle('rb-pdp-bis-on', show);
        box.hidden = !show;
        if (!show) { shownFor = null; return; }
        if (shownFor !== current.id) {
          shownFor = current.id;
          state = done(current.id) ? 'done' : 'button';
          paint();
        }
      }
      function klaviyo(path, body) {
        return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(data.bis.key), {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: '2024-10-15' },
          body: JSON.stringify(body)
        }).then(function (r) { if (!r.ok) throw new Error(r.status); return r; });
      }
      function submit(f) {
        var email = f.email.value.trim();
        var err = f.querySelector('.rb-bis__err');
        var btn = f.querySelector('.rb-bis__submit');
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { err.textContent = T.errEmail; f.email.focus(); return; }
        err.textContent = '';
        btn.setAttribute('aria-busy', 'true');
        btn.disabled = true;
        var variantId = current.id;
        var jobs = [klaviyo('back-in-stock-subscriptions', {
          data: {
            type: 'back-in-stock-subscription',
            attributes: { profile: { data: { type: 'profile', attributes: { email: email } } }, channels: ['EMAIL'] },
            relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } } }
          }
        })];
        if (f.news && f.news.checked && data.bis.list) {
          jobs.push(klaviyo('subscriptions', {
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Back in stock – product page',
                profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } }
              },
              relationships: { list: { data: { type: 'list', id: data.bis.list } } }
            }
          }).catch(function () {})); // the reminder matters most – a failed newsletter sign-up shouldn't block it
        }
        Promise.all(jobs).then(function () {
          store(EMAIL_KEY, email);
          if (f.news && f.news.checked) { try { var st = JSON.parse(localStorage.getItem('rb_letter') || '{}') || {}; st.signed = Date.now(); localStorage.setItem('rb_letter', JSON.stringify(st)); } catch (x) {} }
          try { sessionStorage.setItem('rb_bis_' + variantId, email); } catch (e) {}
          try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ event: 'back_in_stock_signup', variant_id: String(variantId), size: current && current.size });
          } catch (e) {}
          if (current && current.id === variantId) { state = 'done'; paint(); }
        }).catch(function () {
          err.textContent = T.errSend;
          btn.removeAttribute('aria-busy');
          btn.disabled = false;
        });
      }
      box.addEventListener('click', function (e) {
        if (e.target.closest('[data-rb-bis-open]') || e.target.closest('[data-rb-bis-change]')) {
          if (e.target.closest('[data-rb-bis-change]')) { try { sessionStorage.removeItem('rb_bis_' + current.id); } catch (x) {} }
          state = 'form';
          paint();
        }
      });
      box.addEventListener('input', function () {
        var err = box.querySelector('.rb-bis__err');
        if (err) err.textContent = '';
      });
      box.addEventListener('submit', function (e) {
        var f = e.target.closest('[data-rb-bis-form]');
        if (!f) return;
        e.preventDefault();
        e.stopPropagation();
        submit(f);
      });
      return {
        update: update,
        active: function () { return !box.hidden; },
        start: function () {
          if (box.hidden) return;
          if (state === 'button') { state = 'form'; paint(); }
          var top = box.getBoundingClientRect().top + window.scrollY - window.innerHeight / 3;
          window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        },
        soldOutLabel: T.soldOut,
        notifyLabel: T.notify
      };
    })();

    /* ---------- stock note ---------- */
    function paintStock() {
      paintHead();
      if (!stock) return;
      stock.hidden = sizeHead ? true : !(current && current.available && current.last && !needsSize());
    }

    /* ---------- sticky bar (mobile) ---------- */
    var barButton = bar && bar.querySelector('[data-rb-bar-button]');
    var barPrice = bar && bar.querySelector('[data-rb-bar-price]');
    // Carl 1 Oct (late): the bar is there from landing so Add to bag is always one tap away. While the product title is
    // still on screen (or below), the bar is just the full-width button – no second title. Once the title has scrolled
    // up, the bar shows name + price beside the button. It steps aside while the page's own button is in view and at
    // the footer.
    var buttonVisible = true, titlePast = false, footerIn = false;
    function pagePrice(root) {
      var p = (root || info).querySelector('#price-' + sid + ' .price__sale:not([hidden]) .price-item--sale, #price-' + sid + ' .price-item--regular');
      return p ? p.textContent.trim() : '';
    }
    if (barPrice && pagePrice()) barPrice.textContent = pagePrice();
    function paintBar() {
      if (!bar) return;
      var disabled = button && button.disabled && !needsSize();
      var notify = !!(bis && bis.active());
      // Carl 4 Oct: the bar showed nothing after a tap (the page's own button with "Added" is off screen) – it says it too
      if (rbBarDone) barButton.innerHTML = rbBarDone;
      // desktop with the size list beside it: the button keeps saying Add to bag (it opens the list when no size is chosen)
      var deskSize = barSize && data.needsChoice && !window.matchMedia('(max-width: 749px)').matches && sizeInputs().length > 1;
      if (!rbBarDone) barButton.textContent = needsSize() ? (deskSize ? data.strings.add : data.strings.select) : (notify ? bis.notifyLabel : (disabled ? data.strings.soldOut : data.strings.add));
      barButton.classList.toggle('rb-bar--done', !!rbBarDone);
      barButton.disabled = !!disabled && !notify;
      var phone = window.matchMedia('(max-width: 749px)').matches;
      var show = !buttonVisible && !footerIn;
      // phones: just the button while the title is in view; desktop (6 Oct): always picture, name and price
      bar.classList.toggle('rb-pdp-bar--compact', phone && !titlePast);
      // Carl 1 Oct (late): ease in and out instead of popping – the bar stays rendered and slides/fades via .is-shown
      bar.hidden = false;
      bar.classList.toggle('is-shown', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      barButton.tabIndex = show ? 0 : -1;
      if (!show) closeBarList();
      paintBarSize(phone, show);
      document.documentElement.classList.toggle('rb-pdp-bar-on', show);
    }

    /* ---------- desktop bar: size list (Carl 6 Oct, canvas "12 · Product page" PdpBarDesktopSizes) ----------
       Built from the page's own size buttons each time it opens (the theme re-renders them on every change), so the
       page stays the one source: choosing here clicks the size on the page. Sold-out sizes say Notify me and open the
       back-in-stock form. Products without size buttons (one size, dropdowns) keep the plain bar. */
    var barSize = bar && bar.querySelector('[data-rb-bar-size]');
    var barSizeBtn = bar && bar.querySelector('[data-rb-bar-sizebtn]');
    var barSizeLabel = bar && bar.querySelector('[data-rb-bar-sizelabel]');
    var barList = bar && bar.querySelector('[data-rb-bar-list]');
    function sizeInputs() {
      var g = sizeGroup();
      return g ? [].slice.call(g.querySelectorAll('input[type="radio"]')) : [];
    }
    function sizeText(input) {
      var l = input.id && document.querySelector('label[for="' + input.id + '"]');
      var t = l ? (l.childNodes[0] && l.childNodes[0].nodeType === 3 ? l.childNodes[0].textContent : l.textContent) : input.value;
      return String(t || input.value).replace(/\s+/g, ' ').trim().split(' Variant')[0];
    }
    function paintBarSize(phone, show) {
      if (!barSize) return;
      var inputs = data.needsChoice ? sizeInputs() : [];
      var use = !phone && inputs.length > 1;
      barSize.hidden = !use;
      barSizeBtn.tabIndex = use && show ? 0 : -1;
      if (!use) return;
      var on = needsSize() ? null : inputs.filter(function (i) { return i.checked; })[0];
      barSizeLabel.textContent = on ? data.strings.sizeLabel + ' ' + sizeText(on) : data.strings.select;
    }
    function closeBarList() {
      if (!barList || barList.hidden) return;
      barList.hidden = true;
      barSizeBtn.setAttribute('aria-expanded', 'false');
      barSize.classList.remove('is-open');
    }
    function openBarList() {
      var inputs = sizeInputs();
      var picked = needsSize() ? null : inputs.filter(function (i) { return i.checked; })[0];
      barList.innerHTML = '<span class="rb-pdp-bar__lh">' + esc(data.strings.sizeLabel) + '</span>' + inputs.map(function (i, n) {
        var so = i.classList.contains('disabled');
        return '<button type="button" role="option" class="rb-pdp-bar__opt' + (so ? ' is-so' : '') + '" data-n="' + n + '" aria-selected="' + (i === picked) + '">' +
          '<span>' + esc(sizeText(i)) + '</span>' + (so && bis ? '<small>' + esc(data.strings.notify || 'Notify me') + '</small>' : '') + '</button>';
      }).join('');
      barList.hidden = false;
      barSizeBtn.setAttribute('aria-expanded', 'true');
      barSize.classList.add('is-open');
      var first = barList.querySelector('[aria-selected="true"]') || barList.querySelector('.rb-pdp-bar__opt:not(.is-so)');
      if (first) first.focus({ preventScroll: true });
    }
    if (barSize) {
      barSizeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (barList.hidden) openBarList(); else closeBarList();
      });
      barList.addEventListener('click', function (e) {
        var o = e.target.closest('.rb-pdp-bar__opt');
        if (!o) return;
        var input = sizeInputs()[+o.getAttribute('data-n')];
        var so = o.classList.contains('is-so');
        closeBarList();
        barSizeBtn.focus({ preventScroll: true });
        if (!input) return;
        // choose without click(): a click focuses the size on the page and the browser would scroll up to it
        if (!input.checked || needsSize()) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
        if (so && bis) setTimeout(function () { if (bis.active()) bis.start(); }, 450);
      });
      barList.addEventListener('keydown', function (e) {
        var opts = [].slice.call(barList.querySelectorAll('.rb-pdp-bar__opt'));
        var i = opts.indexOf(document.activeElement);
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          var n = opts[(i + (e.key === 'ArrowDown' ? 1 : -1) + opts.length) % opts.length];
          if (n) n.focus();
        } else if (e.key === 'Escape') { closeBarList(); barSizeBtn.focus(); }
      });
      document.addEventListener('click', function (e) { if (!barSize.contains(e.target)) closeBarList(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeBarList(); });
    }
    if (bar) {
      document.body.appendChild(bar); // fixed position must not live inside the theme's transformed wrapper
      if (button && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          buttonVisible = entries[0].isIntersecting;
          paintBar();
        }, { rootMargin: '0px 0px -8px 0px' }).observe(button);
        var titleEl = info.querySelector('.product__title');
        if (titleEl) {
          new IntersectionObserver(function (entries) {
            var e = entries[0];
            titlePast = !e.isIntersecting && e.boundingClientRect.top < 0;
            paintBar();
          }).observe(titleEl);
        }
        // every footer-group section (the first one can be an empty app section) + any <footer>
        var footerParts = document.querySelectorAll('.shopify-section-group-footer-group, footer');
        if (footerParts.length) {
          var inView = new Set();
          var fo = new IntersectionObserver(function (entries) {
            entries.forEach(function (en) { if (en.isIntersecting) inView.add(en.target); else inView.delete(en.target); });
            footerIn = inView.size > 0;
            paintBar();
          });
          footerParts.forEach(function (el) { fo.observe(el); });
        }
      }
      window.addEventListener('resize', paintBar, { passive: true });
      barButton.addEventListener('click', function (e) {
        if (needsSize()) {
          if (barSize && !barSize.hidden) { e.stopPropagation(); openBarList(); return; }
          askForSize();
        } else if (bis && bis.active()) {
          bis.start();
        } else if (button && !button.disabled) {
          button.click();
        }
      });
    }

    /* ---------- ask for a size instead of adding ---------- */
    function sizeGroup() {
      var picker = document.getElementById('variant-selects-' + sid);
      if (!picker) return null;
      var groups = [].filter.call(picker.querySelectorAll('.product-form__input'), function (g) {
        return !g.classList.contains('hidden');
      });
      return groups[0] || picker;
    }
    function askForSize() {
      var g = sizeGroup();
      hinted = true;
      paintHead();
      if (hint) hint.hidden = !!sizeHead;
      if (g) {
        g.classList.remove('rb-pdp-attention');
        void g.offsetWidth;
        g.classList.add('rb-pdp-attention');
        var top = g.getBoundingClientRect().top + window.scrollY - window.innerHeight / 3;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        var first = g.querySelector('input:not(.disabled), select');
        if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 400);
      }
    }
    document.addEventListener('submit', function (e) {
      if (!form || !e.target || e.target.id !== form.id) return;
      if (needsSize()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        askForSize();
      } else if (hem && hem.blocked()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        hem.open();
      } else if (button && !button.disabled && button.getAttribute('aria-disabled') !== 'true') {
        rbAdded();
        rbPending = true;
        clearTimeout(rbPendingT);
        rbPendingT = setTimeout(function () { rbPending = false; }, 8000);
      }
    }, true);
    var rbPendingT = null;
    // "Buy it now" (dynamic checkout) would buy the hidden default size – block it until a size is chosen
    info.addEventListener('click', function (e) {
      if (!needsSize()) return;
      if (e.target.closest('.shopify-payment-button')) {
        e.preventDefault();
        e.stopPropagation();
        askForSize();
      }
    }, true);

    /* ---------- the customer chose a size ---------- */
    function chosen(variant, html) {
      info.removeAttribute('data-rb-needs-size');
      hinted = false;
      if (hint) hint.hidden = true;
      current = variant ? (byId[variant.id] || { id: variant.id, size: variant.options && variant.options[data.sizeIndex], available: variant.available, last: false }) : null;
      if (barPrice) {
        var p = pagePrice(html) || pagePrice();
        if (p) barPrice.textContent = p;
      }
      if (bis) bis.update();
      paintStock();
      paintFit();
      paintBar();
      if (hem) hem.onSize();
    }
    var subscribed = false;
    try {
      /* PUB_SUB_EVENTS / subscribe are top-level declarations in the theme's constants.js / pubsub.js (not on window) */
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
          var d = evt && evt.data;
          if (!d || d.sectionId !== sid) return;
          chosen(d.variant, d.html);
        });
        subscribed = true;
      }
    } catch (e) {}
    // Fallback (and for "unavailable" combinations): read the variant the theme rendered after a size change
    info.addEventListener('change', function (e) {
      if (!e.target.closest || !e.target.closest('variant-selects')) return;
      if (hint) hint.hidden = true;
      if (subscribed) return;
      var tries = 0;
      (function poll() {
        var el = info.querySelector('variant-selects [data-selected-variant]');
        var v = el ? readJSON(el) : null;
        var picked = v && v.options && v.options[data.sizeIndex];
        var checked = info.querySelector('variant-selects input:checked[value="' + (picked || '').replace(/"/g, '') + '"]');
        if (v && checked) return chosen(v, null);
        if (++tries < 20) setTimeout(poll, 150);
      })();
    });

    /* ---------- instant size (Carl 4 Oct: choosing a size felt slow) ----------
       The theme re-renders the product section from the server on every option change (0.5-1 s) and greys out
       Add to bag meanwhile. We already know every variant, so the form gets the new variant id and the button its
       state at once; the server render follows quietly in the background and confirms. */
    (function () {
      var PI = customElements.get('product-info');
      if (PI && !PI.prototype.__rbFast) {
        PI.prototype.__rbFast = true;
        var reset = PI.prototype.resetProductFormState;
        PI.prototype.resetProductFormState = function () {
          if (this.__rbInstant) { this.__rbInstant = false; if (this.productForm) this.productForm.handleErrorMessage(); return; }
          return reset.apply(this, arguments);
        };
      }
      function picked(vs) {
        return [].map.call(vs.querySelectorAll('.product-form__input'), function (g) {
          var i = g.querySelector('input:checked');
          if (i) return i.value;
          var sel = g.querySelector('select');
          return sel && sel.selectedOptions[0] ? sel.selectedOptions[0].value : null;
        });
      }
      info.addEventListener('change', function (e) {
        var vs = e.target.closest && e.target.closest('variant-selects');
        if (!vs || !button) return;
        var vals = picked(vs);
        var v = (data.variants || []).filter(function (x) {
          return x.o && x.o.length === vals.length && x.o.every(function (o, k) { return o === vals[k]; });
        })[0];
        if (!v) return; // unknown combination: let the theme handle it
        info.__rbInstant = true;
        [].forEach.call(info.querySelectorAll('#product-form-' + sid + ' input[name="id"], #product-form-installment-' + sid + ' input[name="id"]'), function (inp) {
          inp.value = v.id;
          inp.disabled = false;
        });
        var label = button.querySelector('span');
        if (v.available) {
          button.removeAttribute('disabled');
          if (label && window.variantStrings) label.textContent = window.variantStrings.addToCart;
        } else {
          button.setAttribute('disabled', 'disabled');
          if (label && window.variantStrings) label.textContent = window.variantStrings.soldOut;
        }
        chosen({ id: v.id, options: v.o, available: v.available }, null);
      }, true);
    })();

    /* ---------- sizes in numeric order + balanced rows (Carl 1 Oct: "44" ended up after "56" on some products) ---------- */
    var mqDesk = window.matchMedia('(min-width: 990px)');
    function tidySizes() {
      var pill = info.querySelector('.variant-selection-container .product-form__input--pill:not(.hidden)');
      if (!pill) return;
      var inputs = [].slice.call(pill.querySelectorAll('input[type="radio"]'));
      var n = inputs.length;
      var nums = inputs.map(function (i) { return parseFloat(String(i.value).replace(',', '.')); });
      if (n > 1 && nums.every(function (x) { return !isNaN(x); })) {
        var sorted = nums.slice().sort(function (a, b) { return a - b; });
        inputs.forEach(function (i, k) {
          var o = String(sorted.indexOf(nums[k]));
          i.style.order = o;
          var l = pill.querySelector('label[for="' + i.id + '"]') || i.nextElementSibling;
          if (l) l.style.order = o;
        });
      }
      // regular + long sizes (e.g. 44–56 and 148–156, Carl 1 Oct): two groups, the long ones on their own row with a caption
      var labs = inputs.map(function (i) { return pill.querySelector('label[for="' + i.id + '"]') || i.nextElementSibling; });
      var isNum = n > 1 && nums.every(function (x) { return !isNaN(x); });
      var longIdx = isNum ? nums.map(function (x, k) { return x >= 100 ? k : -1; }).filter(function (k) { return k >= 0; }) : [];
      var split = longIdx.length > 0 && longIdx.length < n;
      var firstLong = split ? longIdx.reduce(function (a, k) { return nums[k] < nums[a] ? k : a; }, longIdx[0]) : -1;
      var cap = sv ? 'Långa storlekar' : (typeof de !== 'undefined' && de) ? 'Lange Größen' : 'Long sizes';
      labs.forEach(function (l, k) {
        if (!l) return;
        l.classList.toggle('rb-size--long', split && nums[k] >= 100);
        l.classList.toggle('rb-size--long-first', k === firstLong);
        if (k === firstLong) l.setAttribute('data-rb-cap', cap); else l.removeAttribute('data-rb-cap');
      });
      pill.classList.toggle('rb-sizes-split', split);
      var cols = 0;
      if (split) {
        var g = Math.max(n - longIdx.length, longIdx.length);
        if (g <= (mqDesk.matches ? 8 : 7)) cols = g;
      }
      if (!cols && n >= 3) cols = mqDesk.matches ? (n <= 8 ? n : Math.ceil(n / 2)) : (n <= 6 ? n : n <= 8 ? 4 : 5);
      pill.setAttribute('data-rb-tidy', '');
      pill.classList.toggle('rb-sizes-cols', !!cols);
      if (cols) pill.style.setProperty('--rb-cols', cols);
    }
    tidySizes();
    if (mqDesk.addEventListener) mqDesk.addEventListener('change', tidySizes);
    // The theme swaps the whole <variant-selects> for fresh HTML when a size is picked, so an observer on the old element went
    // quiet and the new grid lost its columns (6 sizes became 5 + 1 on mobile). Watch the info column; re-tidy only a fresh grid.
    if ('MutationObserver' in window) {
      var tidyQueued = false;
      new MutationObserver(function () {
        if (tidyQueued) return;
        var p = info.querySelector('.variant-selection-container .product-form__input--pill:not(.hidden)');
        if (!p || p.hasAttribute('data-rb-tidy')) return;
        tidyQueued = true;
        requestAnimationFrame(function () { tidyQueued = false; tidySizes(); });
      }).observe(info, { childList: true, subtree: true });
    }

    /* ---------- Added in place (Carl 4 Oct, Motion Lab "Size chosen, added in place") ----------
       After Add to bag the button says "Added · size 50" for a moment (no "View bag" link, Carl 4 Oct). It shows at
       once on the tap (the cart call itself takes about a second) and steps back if the cart answers with an error. With
       "Stay on the page after Add to bag" on (theme settings, R&B · Brand motion) the bag drawer does not open; the bag
       count in the header rolls up instead (assets/rb-cart-drawer.js). The size-box glide and the colour crossfade were
       removed 4 Oct (Carl: lag, colour change didn't look good). */
    // Added in place
    var rbDoneT = null, rbPending = false, rbBarDone = null;
    function rbUndo() {
      rbPending = false;
      clearTimeout(rbDoneT);
      var btn = document.getElementById('ProductSubmitButton-' + sid);
      if (btn) btn.classList.remove('rb-add--done');
      rbBarDone = null;
      paintBar();
    }
    function rbAdded() {
      var btn = document.getElementById('ProductSubmitButton-' + sid);
      if (!btn) return;
      var done = btn.querySelector('.rb-add__done');
      if (!done) {
        done = document.createElement('span');
        done.className = 'rb-add__done';
        done.setAttribute('aria-hidden', 'true');
        btn.appendChild(done);
      }
      var size = current && current.size;
      var word = sv ? 'Tillagd' : de ? 'Hinzugefügt' : 'Added';
      var sizeWord = sv ? 'storlek' : de ? 'Größe' : 'size';
      done.innerHTML = '<svg width="13" height="10" viewBox="0 0 13 10" fill="none" stroke="currentColor" stroke-width="1.2"><path d="M1 5l4 4 7-8"/></svg>' +
        esc(word + (size && data.sizeIndex != null && (data.variants || []).length > 1 ? ' · ' + sizeWord + ' ' + size : ''));
      btn.classList.remove('rb-add--done');
      void btn.offsetWidth;
      btn.classList.add('rb-add--done');
      clearTimeout(rbDoneT);
      rbBarDone = done.innerHTML;
      paintBar();
      rbDoneT = setTimeout(function () { btn.classList.remove('rb-add--done'); rbBarDone = null; paintBar(); }, 2600);
    }
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
          if (!evt || evt.source !== 'product-form') return;
          var c = evt.cartData;
          if (!c || c.status || c.errors) return;
          var f = form && form.querySelector('[name="id"]');
          if (f && evt.productVariantId && String(evt.productVariantId) !== String(f.value)) return;
          if (rbPending) { rbPending = false; return; } // already shown on the tap
          rbAdded();
        });
        subscribe(PUB_SUB_EVENTS.cartError, function (evt) {
          if (evt && evt.source === 'product-form') rbUndo();
        });
      }
    } catch (e) {}

    /* ---------- description: 3 lines + "Read more" (Carl 1 Oct, like Drake's) ---------- */
    (function () {
      var d = info.querySelector('.product__description');
      if (!d || d.querySelector('.rb-desc__more')) return;
      var first = d.querySelector('p') || d;
      var lh = parseFloat(getComputedStyle(first).lineHeight) || 22;
      var max = Math.round(lh * 3);
      if (d.scrollHeight <= max + lh * 1.5) return; // short descriptions stay as they are
      d.classList.add('rb-desc', 'rb-desc--clamped');
      d.style.setProperty('--rb-desc-h', max + 'px');
      var more = sv ? 'Läs mer' : de ? 'Mehr lesen' : 'Read more', less = sv ? 'Visa mindre' : de ? 'Weniger anzeigen' : 'Show less';
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'rb-desc__more';
      b.setAttribute('aria-expanded', 'false');
      b.textContent = more;
      d.insertAdjacentElement('afterend', b);
      b.addEventListener('click', function () {
        var open = d.classList.contains('rb-desc--clamped');
        d.classList.toggle('rb-desc--clamped', !open);
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
        b.textContent = open ? less : more;
        if (!open) d.scrollIntoView({ block: 'nearest' });
      });
    })();

    /* ---------- desktop: gallery pane height = screen minus the sticky header (v3 D) ---------- */
    (function () {
      var head = document.querySelector('.section-header, sticky-header');
      function setHead() { if (head) info.style.setProperty('--rb-head', Math.round(head.getBoundingClientRect().height) + 'px'); }
      setHead();
      window.addEventListener('resize', setHead, { passive: true });

      /* sticky info column (Carl 1 Oct, like Loro Piana): pinned 3.2rem under the header (follows it when it slides
         in/out) so title, sizes and Add to bag stay in view while the images scroll.
         6 Oct: a column taller than the screen no longer scrolls on its own (its end, Pairs well with, was missed).
         It moves with the page: scrolling down it runs until its end is 3.2rem above the bottom of the screen and
         sticks there; scrolling up it runs back until its top is under the header again. */
      var iw = info.querySelector('.product__info-wrapper');
      if (!iw) return;
      var tk = false, settleT = 0, cur = null, lastY = window.pageYOffset;
      function stick() {
        tk = false;
        var y = window.pageYOffset, dy = y - lastY; lastY = y;
        if (!mqDesk.matches) { iw.style.removeProperty('--rb-info-top'); cur = null; return; }
        var hb = head ? Math.max(0, head.getBoundingClientRect().bottom) : 0;
        var topMax = Math.round(hb + 32);                                  // top under the header
        var topMin = Math.min(topMax, Math.round(window.innerHeight - iw.offsetHeight - 32)); // end in view
        if (cur === null) cur = topMax;
        cur = Math.max(topMin, Math.min(topMax, cur - dy));
        iw.style.setProperty('--rb-info-top', Math.round(cur) + 'px');
      }
      function queue() { if (!tk) { tk = true; requestAnimationFrame(stick); } clearTimeout(settleT); settleT = setTimeout(stick, 340); }
      window.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue, { passive: true });
      /* the column grows when Pairs well with loads or an accordion opens */
      if ('ResizeObserver' in window) new ResizeObserver(queue).observe(iw);
      stick();
    })();

    /* ---------- mobile gallery: dots on the image (option A) instead of the "1/12" counter ---------- */
    (function () {
      var mw = info.querySelector('.product__media-wrapper');
      if (!mw) return;
      var dots = document.createElement('div');
      dots.className = 'rb-dots';
      dots.setAttribute('aria-hidden', 'true');
      mw.appendChild(dots);
      var ul = null, count = 0, raf = 0, rebuildT = 0;
      function slides() {
        return ul ? [].filter.call(ul.children, function (li) { return li.classList.contains('product__media-item') && getComputedStyle(li).display !== 'none'; }) : [];
      }
      function paint() {
        raf = 0;
        if (!ul || count < 2) return;
        var i = Math.max(0, Math.min(count - 1, Math.round(ul.scrollLeft / Math.max(1, ul.clientWidth))));
        [].forEach.call(dots.children, function (d, k) { d.classList.toggle('is-active', k === i); });
        // hairline (Carl 1 Oct): the black segment follows the swipe
        dots.style.setProperty('--rb-p', (ul.scrollLeft / Math.max(1, ul.clientWidth)).toFixed(3));
      }
      function onScroll() { if (!raf) raf = requestAnimationFrame(paint); }
      function build() {
        var next = mw.querySelector('.product__media-list');
        if (next !== ul) {
          if (ul) ul.removeEventListener('scroll', onScroll);
          ul = next;
          if (ul) ul.addEventListener('scroll', onScroll, { passive: true });
        }
        var list = slides();
        var n = list.length;
        if (n !== count) {
          count = n;
          var html = '';
          for (var k = 0; k < (n > 1 ? n : 0); k++) html += '<span></span>';
          dots.innerHTML = html;
          dots.style.setProperty('--rb-n', n || 1);
        }
        paint();
      }
      build();
      if ('MutationObserver' in window) {
        new MutationObserver(function (list) {
          if (list.every(function (m) { return dots.contains(m.target); })) return;
          clearTimeout(rebuildT);
          rebuildT = setTimeout(build, 60);
        }).observe(mw, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
      }
    })();

    /* ---------- image viewer (Carl 1 Oct: D2 desktop + M1 mobile, canvas "Image zoom") ----------
       Tap / click an image → white full-screen viewer (PhotoSwipe 5, MIT, bundled as assets/rb-photoswipe.*).
       Desktop: click to zoom 2.5×, the zoomed image follows the cursor; arrows, keys, thumbnails, Esc / ✕.
       Mobile: swipe, pinch or double-tap to zoom, swipe down or ✕ to close; dots + a one-time hint.
       Slides = the images currently shown in the gallery (respects the colour grouping), in gallery order. */
    (function () {
      var mw = info.querySelector('.product__media-wrapper');
      if (!mw) return;
      var me = document.querySelector('script[src*="/rb-pdp.js"]');
      var base = me ? me.src.split('/rb-pdp.js')[0] + '/' : null;
      if (!base) return;
      var libP = null;
      function loadLib() {
        if (libP) return libP;
        libP = new Promise(function (res, rej) {
          if (!document.querySelector('link[data-rb-pswp]')) {
            var l = document.createElement('link');
            l.rel = 'stylesheet';
            l.href = base + 'rb-photoswipe.css';
            l.setAttribute('data-rb-pswp', '');
            document.head.appendChild(l);
          }
          if (window.PhotoSwipe) return res(window.PhotoSwipe);
          var s = document.createElement('script');
          s.src = base + 'rb-photoswipe.umd.min.js';
          s.async = true;
          s.onload = function () { window.PhotoSwipe ? res(window.PhotoSwipe) : rej(); };
          s.onerror = function () { libP = null; rej(); };
          document.head.appendChild(s);
        });
        return libP;
      }
      // warm up on first intent so the first tap opens instantly
      ['pointerenter', 'touchstart'].forEach(function (ev) { mw.addEventListener(ev, function () { loadLib().catch(function () {}); }, { once: true, passive: true }); });

      function sized(src, w) {
        if (!src) return src;
        src = src.indexOf('//') === 0 ? location.protocol + src : src;
        return /[?&]width=\d+/.test(src) ? src.replace(/([?&])width=\d+/, '$1width=' + w) : src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=' + w;
      }
      function items() {
        var lis = [].filter.call(mw.querySelectorAll('.product__media-list > .product__media-item'), function (li) {
          return getComputedStyle(li).display !== 'none' && li.querySelector('img');
        });
        return lis.map(function (li) {
          var img = li.querySelector('img');
          var w0 = parseInt(img.getAttribute('width'), 10) || 4, h0 = parseInt(img.getAttribute('height'), 10) || 5;
          var W = 2000, H = Math.round(W * h0 / w0);
          return { li: li, src: sized(img.getAttribute('src'), W), thumb: sized(img.getAttribute('src'), 200), width: W, height: H, alt: img.getAttribute('alt') || '' };
        });
      }

      var T = sv ? { close: 'Stäng', prev: 'Föregående bild', next: 'Nästa bild', zoom: 'Zooma', hint: 'Nyp eller dubbeltryck för att zooma' }
                 : de ? { close: 'Schließen', prev: 'Vorheriges Bild', next: 'Nächstes Bild', zoom: 'Zoomen', hint: 'Zum Zoomen auseinanderziehen oder doppelt tippen' }
                 : { close: 'Close', prev: 'Previous image', next: 'Next image', zoom: 'Zoom', hint: 'Pinch or double-tap to zoom' };
      var mqTouch = window.matchMedia('(max-width: 749px), (hover: none)');

      function open(list, index) {
        loadLib().then(function (PhotoSwipe) {
          var touch = mqTouch.matches;
          var pswp = new PhotoSwipe({
            dataSource: list.map(function (x) { return { src: x.src, width: x.width, height: x.height, alt: x.alt }; }),
            index: index,
            bgOpacity: 1,
            showHideAnimationType: 'fade',
            initialZoomLevel: 'fit',
            secondaryZoomLevel: function (z) { return z.fit * 2.5; },
            maxZoomLevel: function (z) { return Math.max(z.fit * 4, 1); },
            imageClickAction: touch ? 'close' : 'zoom-or-close',
            tapAction: touch ? 'toggle-controls' : 'close',
            doubleTapAction: 'zoom',
            closeOnVerticalDrag: true,
            padding: touch ? { top: 0, bottom: 0, left: 0, right: 0 } : { top: 24, bottom: 24, left: 120, right: 24 },
            wheelToZoom: false,
            preload: [1, 2],
            closeTitle: T.close, arrowPrevTitle: T.prev, arrowNextTitle: T.next, zoomTitle: T.zoom,
            mainClass: 'rb-pswp' + (touch ? ' rb-pswp--touch' : ''),
            zoom: false
          });

          pswp.on('uiRegister', function () {
            // desktop: thumbnail column
            pswp.ui.registerElement({
              name: 'rb-thumbs', className: 'rb-pswp-thumbs', appendTo: 'wrapper', order: 9,
              onInit: function (el) {
                el.innerHTML = list.map(function (x, k) { return '<button type="button" data-k="' + k + '" aria-label="' + (k + 1) + ' / ' + list.length + '"><img src="' + x.thumb + '" alt="" loading="lazy"></button>'; }).join('');
                el.addEventListener('click', function (e) { var b = e.target.closest('button'); if (b) pswp.goTo(+b.getAttribute('data-k')); });
                function mark() { [].forEach.call(el.children, function (b, k) { b.classList.toggle('is-active', k === pswp.currIndex); }); }
                pswp.on('change', mark); mark();
              }
            });
            // mobile: position line
            pswp.ui.registerElement({
              name: 'rb-dots', className: 'rb-pswp-dots', appendTo: 'wrapper', order: 10,
              onInit: function (el) {
                if (list.length < 2) { el.hidden = true; return; }
                // Carl 8 Oct: the hairline with a black segment, as under the gallery on the page (not dots)
                el.style.setProperty('--rb-n', list.length);
                function mark() { el.style.setProperty('--rb-p', pswp.currIndex); }
                pswp.on('change', mark); mark();
              }
            });
            // mobile: one-time hint
            pswp.ui.registerElement({
              name: 'rb-hint', className: 'rb-pswp-hint', appendTo: 'wrapper', order: 11,
              onInit: function (el) {
                if (!touch || store('rb_zoom_hint')) { el.hidden = true; return; }
                el.textContent = T.hint;
                store('rb_zoom_hint', '1');
                var hide = function () { el.classList.add('is-gone'); };
                setTimeout(hide, 2600);
                pswp.on('zoomPanUpdate', function () { if (pswp.currSlide && pswp.currSlide.currZoomLevel > pswp.currSlide.zoomLevels.initial * 1.05) hide(); });
              }
            });
          });

          // desktop: once zoomed, the image follows the cursor (no dragging needed)
          if (!touch) {
            var follow = function (e) {
              var s = pswp.currSlide;
              if (!s || !s.isZoomable() || s.currZoomLevel <= s.zoomLevels.initial * 1.01) return;
              var b = s.bounds, vp = pswp.viewportSize;
              var px = Math.min(1, Math.max(0, e.clientX / vp.x)), py = Math.min(1, Math.max(0, e.clientY / vp.y));
              s.pan.x = b.max.x - px * (b.max.x - b.min.x);
              s.pan.y = b.max.y - py * (b.max.y - b.min.y);
              s.applyCurrentZoomPan();
            };
            pswp.on('bindEvents', function () { pswp.element.addEventListener('mousemove', follow); });
            pswp.on('zoomPanUpdate', function () {});
            pswp.on('imageClickAction', function (ev) {
              // after the click-zoom, jump straight to the point under the cursor
              var oe = ev.originalEvent;
              if (oe) setTimeout(function () { follow(oe); }, 340);
            });
          }
          pswp.on('close', function () {
            var li = list[pswp.currIndex] && list[pswp.currIndex].li;
            var ul = li && li.parentElement;
            if (li && ul && ul.scrollWidth > ul.clientWidth + 2) ul.scrollTo({ left: li.offsetLeft - ul.offsetLeft, behavior: 'auto' });
          });
          pswp.init();
        }).catch(function () {
          // library didn't load: fall back to the theme's own lightbox
          var opener = list[index] && list[index].li.querySelector('modal-opener button, .product__modal-opener');
          if (opener) { mw.removeEventListener('click', onClick, true); opener.click(); mw.addEventListener('click', onClick, true); }
        });
      }

      function onClick(e) {
        var li = e.target.closest('.product__media-item');
        if (!li || !mw.contains(li) || !li.querySelector('img')) return;
        if (e.target.closest('a[href], .rb-pdp-back, button:not(.product__media-toggle)')) {
          if (!e.target.closest('.product__media-toggle')) return;
        }
        var list = items();
        var idx = list.map(function (x) { return x.li; }).indexOf(li);
        if (idx < 0) return;
        e.preventDefault();
        e.stopPropagation();
        open(list, idx);
      }
      mw.addEventListener('click', onClick, true);
      mw.classList.add('rb-zoomable');
    })();

    /* ---------- initial state ---------- */
    if (!needsSize()) {
      var sel = info.querySelector('variant-selects [data-selected-variant]');
      var v = sel ? readJSON(sel) : null;
      if (v) current = byId[v.id] || null;
    }
    if (bis) bis.update();
    paintStock();
    paintFit();
    paintFitLine();
    paintBar();
    if (hem) hem.onSize();

    /* ---------- mobile back link on the image ---------- */
    var back = info.querySelector('[data-rb-back]');
    var media = info.querySelector('.product__media-wrapper');
    if (back && media) {
      try {
        var ref = document.referrer ? new URL(document.referrer) : null;
        if (ref && ref.origin === location.origin) {
          var m = ref.pathname.match(/\/collections\/([^/?#]+)\/?$/);
          if (m && m[1] !== 'all') {
            back.href = ref.pathname + ref.search;
            var label = decodeURIComponent(m[1]).replace(/-\d+$/, '').replace(/-/g, ' ');
            back.querySelector('span').textContent = label.charAt(0).toUpperCase() + label.slice(1);
          }
        }
      } catch (e) {}
      media.appendChild(back);
      info.classList.add('rb-pdp-has-back');

      /* Carl 30 Sep: the back link keeps floating (top left) once the image has scrolled away – mobile only.
         A copy lives on <body> so position: fixed isn't trapped by the gallery's transformed wrappers. */
      var floatBack = back.cloneNode(true);
      floatBack.classList.add('rb-pdp-back--float');
      floatBack.removeAttribute('data-rb-back');
      floatBack.setAttribute('aria-hidden', 'true');
      floatBack.tabIndex = -1;
      document.body.appendChild(floatBack);
      var pastImage = false, pastProduct = false;
      /* Carl 6 Oct: gone again once the services row (or the footer) comes into view, the visitor has finished the product. */
      var endMark = document.querySelector('.rbsv') || document.querySelector('[data-rb-footer], footer');
      if (endMark && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          pastProduct = e.isIntersecting || e.boundingClientRect.top < 0;
          placeFloat();
        }, { threshold: 0 }).observe(endMark);
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          pastImage = !e.isIntersecting && e.boundingClientRect.top < 0 && window.matchMedia('(max-width: 749px)').matches;
          placeFloat();
        }, { threshold: 0 }).observe(back);
      }
      // The theme's header slides back in on scroll-up: keep the link just below it instead of on top of the logo.
      var header = document.querySelector('.section-header, sticky-header, .header-wrapper');
      var ticking = false;
      /* Carl 1 Oct (late): it no longer rides over the sizes while reading down. It comes back together with the
         header when the visitor scrolls up (the moment they look for a way back), easing in/out like the bar. */
      function placeFloat() {
        ticking = false;
        var bottom = header ? header.getBoundingClientRect().bottom : 0;
        var show = pastImage && !pastProduct && bottom > 1;
        if (show) floatBack.style.top = (bottom + 12) + 'px';
        if (floatBack.classList.contains('is-shown') !== show) {
          floatBack.classList.toggle('is-shown', show);
          floatBack.setAttribute('aria-hidden', show ? 'false' : 'true');
          floatBack.tabIndex = show ? 0 : -1;
        }
      }
      var settle = null;
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(placeFloat); }
        // the header animates in/out after the scroll event – measure again once it has settled
        clearTimeout(settle);
        settle = setTimeout(placeFloat, 320);
      }, { passive: true });
      if (header && 'MutationObserver' in window) {
        new MutationObserver(function () { requestAnimationFrame(placeFloat); setTimeout(placeFloat, 320); })
          .observe(header, { attributes: true, attributeFilter: ['class', 'style'] });
      }
    }
  }

  function boot() {
    document.querySelectorAll('script[id^="RbPdpData-"]').forEach(function (el) {
      var data = readJSON(el);
      if (data) init(data);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* Accessibility: closed accordions and the closed product-info sidebar are aria-hidden; make them inert too,
   so keyboard users and agents can't tab into hidden content. Follows every aria-hidden change. */
(function () {
  var SEL = '.product-info-accordion__content, #product-info-sidebar';
  function sync(el) {
    if (el.getAttribute('aria-hidden') === 'true') el.setAttribute('inert', '');
    else el.removeAttribute('inert');
  }
  function start() {
    [].forEach.call(document.querySelectorAll(SEL), sync);
    new MutationObserver(function (list) {
      list.forEach(function (m) { if (m.target.matches && m.target.matches(SEL)) sync(m.target); });
    }).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['aria-hidden'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
